import { useLocation } from 'react-router-dom';

export function useLoginHint() {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  return search.get('login_hint');
}

export default useLoginHint;
